// extracted by mini-css-extract-plugin
export default {"buttons":"api-permission-prompt-m_buttons-LXEXiZpg common-m_flexRow-ZPndn63a"};